<template>
  <div class="poster">
    <div class="main">
      <van-tabs
        v-model="active"
        border
        color="#31D5BF"
        title-active-color="#101010"
        line-width="71px"
        @click="gettab"
      >
        <van-tab title="精品海报"></van-tab>
        <van-tab title="我分享的"></van-tab>
      </van-tabs>
      <van-divider style="margin: 0 12px" />
      <div class="group" v-if="active == 0">
        <div class="flex ml-10" style="overflow-x: auto; height: 100px">
          <div
            v-for="(item, index) in btnlist"
            :key="index"
            class="btn"
            :class="{ btn_active: index == checked }"
            @click="checkbtn(index, item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <van-empty description="" v-if="list.length == 0" />
      <van-list
        v-model="listLoading"
        :finished="isfinished"
        :finished-text="list.length > 0 ? '没有更多了' : '暂无海报'"
        @load="getmore"
        :offset="1000"
      >
        <div class="list flex">
          <div
            v-for="(item, index) in list"
            :key="index"
            @click="todetail(item)"
            class="mt-10 mr8"
            
          >
            <div class="rel posterimg">
              <van-image
                :src="
                  item.imgUrl +
                  '?x-oss-process=image/resize,m_fill,w_215,h_298/quality,q_70'
                "
                class="imgs"
              />
            </div>
            <div class="name van-ellipsis">{{ item.name }}</div>
          </div>
        </div>
      </van-list>
    </div>
    <img
      src="../../assets/img/poster/search.png"
      class="search"
      @click="() => this.$router.push({ path: '/search' })"
    />
  </div>
</template>
<script>
import { posterCategory, poster, userPoster, posterdetail } from "@/api/poster";
import { setyoumeng } from "../../utils/index";
export default {
  data() {
    return {
      btnlist: [{ name: "推荐", id: "" }], //分类
      checked: 0,
      active: 0,
      list: [], //海报啊列表
      page: 0,
      categoryId: "", //分类id
      isfinished: false,
      userid: "", //用户id
      listLoading: false,
    };
  },
  methods: {
    // 分类选择
    checkbtn(inx, itm) {
      this.categoryId = itm.id;
      this.checked = inx;
      this.list = [];
      this.page = 0;
      this.isfinished = false;
      this.getlist();
    },
    // 获取分类
    getCategory() {
      let data = {
        page: 0,
        size: 99,
        sort: "id,desc",
        enabled: true,
      };
      posterCategory(data).then((res) => {
        this.btnlist = this.btnlist.concat(res.content);
      });
    },
    // 海报列表
    getlist() {
      if (this.isfinished) {
        return;
      }
      if (this.iscan) {
        return;
      }
      this.iscan = true;
      if (this.active == 0) {
        let data = {
          categoryId: this.categoryId,
          enabled: 1,
          page: this.page,
          size: 9,
          sort: ["isTop,desc", "id,desc"],
        };
        if(this.categoryId==''){
          data.isTop=true
        }
        this.iscan = true;
        poster(data).then((res) => {
          if (res.content.length > 0) {
            if (this.page == 0) this.list = [];
            this.page++;
            this.list = this.list.concat(res.content);
            this.listLoading = false;
            this.iscan = false;
          } else {
            this.isfinished = true;
            this.listLoading = false;
            this.iscan = false;
          }
        });
      } else {
        let data = {
          categoryId: this.categoryId,
          // enabled: 1,
          page: this.page,
          size: 9,
          userId: this.userid,
        };
        userPoster(data).then((res) => {
          if (res.content.length > 0) {
            if (this.page == 0) this.list = [];
            this.page++;
            res.content.map((item) => {
              this.getpost(item);
            });
            this.listLoading = false;
            this.iscan = false;
          } else {
            this.isfinished = true;
            this.listLoading = false;
            this.iscan = false;
          }
        });
      }
    },
    // 加载更多
    getmore() {
      this.getlist();
    },
    //
    gettab(name, title) {
      this.list = [];
      this.page = 0;
      this.isfinished = false;
      this.getlist();
    },
    todetail(itm) {
      console.log(itm);
      this.$router.push({ path: "/postersetting", query: { ...itm } });
    },
    getinfo() {
      userinfo().then((res) => {
        this.userid = res.id;
        if (!this.$store.state.user.user.user) {
          this.$store.commit("SET_USER", { user: res });
        }
        console.log(this.$store.state.user.user);
      });
    },

    getpost(id) {
      posterdetail(id).then((res) => {
        this.list.push(res);
      });
    },
  },
  mounted() {
    // 友盟统计添加
    setyoumeng(
      "https://s9.cnzz.com/z_stat.php?id=1279766165&web_id=1279766165"
    );
    // -------------------
    this.getCategory();
    // this.getlist();
    if (!this.$store.state.user.user.user) {
      this.getinfo();
    } else {
      this.userid = this.$store.state.user.user.user.id;
    }
  },
};
</script>
<style lang="less" >
.poster {
  width: 100%;
  .van-tab {
    font-size: 15px !important;
  }
  .van-tab--active {
    font-size: 18px !important;
  }

  .main {
    width: 358px;
    // height: 800px;
    font-family: Roboto;
    border: 1px solid rgba(255, 255, 255, 100);
    border-radius: 2px;
    margin: 20px auto;
    background: #fff;
    .group {
      width: 350px;
      overflow: hidden;
      height: 38px;
    }
    .btn {
      width: 70px;
      height: 28px;
      line-height: 28px;
      border-radius: 2px;
      background-color: rgba(255, 255, 255, 100);
      color: rgba(49, 73, 91, 100);
      font-size: 13px;
      text-align: center;
      font-family: Roboto;
      border: 1px solid rgba(237, 241, 245, 100);
      margin-right: 10px;
      margin-top: 8px;
      flex-shrink: 0;
    }
    .btn_active {
      background-color: rgba(93, 199, 185, 100) !important;
      color: rgba(246, 245, 245, 100) !important;
    }

    .bottom1 {
      width: 100%;
      height: 56px;
      line-height: 56px;
      color: rgba(16, 16, 16, 100);
      font-size: 15px;
      text-align: center;
      font-family: SourceHanSansSC-regular;
    }
    .down {
      width: 15px !important;
      height: 15px !important;
    }
    .list {
      flex-wrap: wrap;
      margin: 9px auto 0;
      // justify-content: space-between;
      .poster {
      }
      .mr8 {
        margin-left: 8px;
      }
      .posterimg {
        width: 108px;
        height: 149px;
        border-radius: 3px 3px 0px 0px;
        border: 1px solid rgba(237, 237, 237, 100);
        border-bottom: 0;
        overflow: hidden;
        .imgs {
          width: 100%;
          height: 100%;
        }
      }
      .istop {
        width: 55px;
        height: 55px;
        position: absolute;
        right: 0;
        top: 0;
      }
      .name {
        width: 108px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        border: 1px solid rgba(237, 237, 237, 100);
        // border-top: 0;
      }
    }
  }
  .search {
    width: 50px;
    height: 50px;
    position: fixed;
    right: 10px;
    bottom: 100px;
  }
  .van-list {
    padding-bottom: 10px;
  }
}
</style>